module.exports = __webpack_public_path__ + "img/03.45d56abc.png";